import React from "react";
import { FormControl, TextField } from "@material-ui/core";

const TextInput = (props) => {
  const { state, disabled, type, onChange, errors, value, label, ...rest } = props;
  React.useEffect(() => console.log(""), [errors, value]);

  return (
    <>
      <FormControl
        style={{ width: "100%", marginTop: 0, paddingLeft: 0 }}
        className="mp_0"
      >
        <TextField
          id="outlined-basic"
          margin="dense"
          variant="outlined"
          label={label ? label : null}
          onChange={onChange}
          name={state}
          size="small"
          style={{ backgroundColor: "#fff" }}
          disabled={disabled}
          value={value}
          className="mp_0"
          type={type === undefined ? "text" : type}
          {...rest}
        />
      </FormControl>
    </>
  );
};

export default TextInput;
